<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>Genera Codice Attivazione</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-margin">
    <ion-row *ngIf="showFiscalCodeField">
      <ion-col size="12">
        <p>
          Inserisci i dati necessari del paziente e poi clicca su
          <strong>Genera codice</strong>.
        </p>

        <ion-item>
          
          <ion-input placeholder="Codice fiscale del paziente" [formControl]="fiscalCodeControl" minlength="16"
                     maxlength="16" class="ion-text-uppercase c3-monospace" #cfInput>
          </ion-input>
          <ion-note slot="end">{{ $any(cfInput.value)?.length || 0 }}/16</ion-note>
        </ion-item>


      </ion-col>
    </ion-row>

    <ion-row *ngIf="showEmailField">
      <ion-col size="12">
        <p>
          Inserisci qua sotto l'email del paziente
        </p>
        <ion-item>
          <ion-input placeholder="Email del paziente" [formControl]="emailControl"
                     class="ion-text-uppercase c3-monospace">
          </ion-input>
        </ion-item>
        <ion-note *ngIf="emailControl.errors && emailControl.dirty" color="danger">
          Inserire un indirizzo mail valido
        </ion-note>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="showPhoneField">
      <ion-col size="12">
        <p>
          Inserisci qua sotto il telefono del paziente
        </p>
        <ion-item>
          <ion-input placeholder="Telefono paziente" [formControl]="telefonoControl"
                     class="ion-text-uppercase c3-monospace">
          </ion-input>
        </ion-item>
        <ion-note *ngIf="telefonoControl.errors && telefonoControl.dirty" color="danger">
          Inserire un numero di telefono valida
        </ion-note>

      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <c3-app-activation-code-view [patientFiscalCode]="data.patientFiscalCode" (activationCodeEmitter)="hideGenerateButton($event)"></c3-app-activation-code-view>
      </ion-col>

      <ng-container *c3ShowTrecEnv="'development'">
        <ion-col size="12">
          <div class="c3-flex">
            <p>
              <span>Codice fiscale: </span>
              <span class="c3-monospace">{{ fiscalCodeControl.value }}</span>
            </p>
            <c3-copy small [copyText]="fiscalCodeControl.value"></c3-copy>
          </div>
        </ion-col>
      </ng-container>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="ion-text-justify">
        <p>
          Con questo codice il paziente potrà attivare l'app una volta che questa è stata installata
          sul dispositivo. Il codice ha una durata limitata e deve quindi essere comunicato al
          paziente prima della sua scadenza altrimenti non potrà più essere utilizzato.
        </p>
        <p *ngIf="showPhoneField && showEmailField">
          Il codice di attivazione sarà composto da una prima parte recapitata tramite email e una seconda parte inviata
          tramite messaggio al numero indicato.
        </p>
        <p *ngIf="showPhoneField && !showEmailField">
          Il codice di attivazione sarà composto da una prima parte dettata dal medico al paziente e una seconda parte inviata
          tramite messaggio al numero indicato.
        </p>
        <p>Nel caso in cui il codice sia scaduto, è possibile generarne uno nuovo.</p>
        <p *ngIf="data.firstTime">
          <ion-note>
            <span>
              Nota: Il codice può essere anche rigenerato successivamente dalla tab "Attivazione
              App" della pagina generale del paziente
            </span>
          </ion-note>
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="primary" *ngIf="showFiscalCodeField && showGenerateButton" (click)="onGenerateCode()"
                  [disabled]="fiscalCodeControl.invalid || (showEmailField && emailControl.invalid) || (showPhoneField && telefonoControl.invalid)">
        <span>Genera codice</span>
        <ion-icon slot="end" [src]="'key-outline' | getIcon"></ion-icon>
      </ion-button>

      <ion-button color="secondary" *ngIf="!showFiscalCodeField && showGenerateButton" (click)="onGenerateCode()"
                  [disabled]="(showEmailField && emailControl.invalid) || (showPhoneField && telefonoControl.invalid)">
        <span>Genera codice</span>
        <ion-icon slot="end" [src]="'reload' | getIcon"></ion-icon>
      </ion-button>

      <ion-button color="danger" (click)="onClose()">Chiudi</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
